import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActionService } from '@mglsk/ng-actions';
import { MenubarModule } from 'primeng/menubar';

@Component({
    selector: 'mglsk-view-actions',
    imports: [MenubarModule],
    templateUrl: './view-actions.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewActionsComponent {
  actionService = inject(ActionService);

  actions = this.actionService.actions;
}
